export default "__VITE_ASSET__DepHofZd__"